export class WindowMedias<T> {
  xl?: T;
  lg?: T;
  md?: T;
  sm?: T;
  xs?: T;

  constructor() {
  }
}
